/** Per-tab return path (sessionStorage); Redux persist is shared across tabs so each tab keeps its own URL here. */

export function isSafeReturnPath(path: string): boolean {
  if (!path || path.length > 4096) return false
  return path.startsWith('/') && !path.startsWith('//')
}

/**
 * Path (pathname + search + hash) to restore after MSAL login. Same-origin only.
 */
export function getPostLogoutCapturePath(): string | null {
  const path =
    window.location.pathname + window.location.search + window.location.hash
  if (path === '/logout' || path.startsWith('/logout?')) {
    return null
  }
  return path
}

export function createPostLogoutReturnPathHelpers(sessionStorageKey: string) {
  function getSessionPostLogoutReturnPath(): string | null {
    try {
      const v = sessionStorage.getItem(sessionStorageKey)
      return v && isSafeReturnPath(v) ? v : null
    } catch {
      return null
    }
  }

  function setSessionPostLogoutReturnPath(path: string | null): void {
    try {
      if (!path) {
        sessionStorage.removeItem(sessionStorageKey)
      } else {
        sessionStorage.setItem(sessionStorageKey, path)
      }
    } catch {
      /* ignore */
    }
  }

  function clearSessionPostLogoutReturnPath(): void {
    setSessionPostLogoutReturnPath(null)
  }

  return {
    getPostLogoutCapturePath,
    isSafeReturnPath,
    getSessionPostLogoutReturnPath,
    setSessionPostLogoutReturnPath,
    clearSessionPostLogoutReturnPath,
  }
}
